import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import 'typeface-ubuntu';
import 'typeface-roboto';
import 'typeface-montserrat';
import 'typeface-lato';
import 'typeface-open-sans';
import 'typeface-playfair-display';
import 'typeface-poppins';
import 'typeface-roboto-slab';
import 'typeface-nunito';
import 'typeface-merriweather';
import 'typeface-source-sans-pro';
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./redux/store";

//the global error handling snippet here
window.addEventListener('error', (event) => {
  if (event.message.includes('ResizeObserver loop limit exceeded')) {
    event.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
